<script setup lang="tsx">
import jiraCbStore from '@/stores/jira-checkboxes'
import methodEditor from '@/stores/method-editor'
import iconPath from '@/assets/images/jira-1.svg'
import { computed } from 'vue'
import { hasPermission } from '@/services/utils'
import { PermAllJiraExport, PermOwnJiraExport } from '@/models/enums-generated'

const editor = methodEditor()
const jiraCb = jiraCbStore()

const handleJiraCheckboxChange = async () => {
	if (isShowModal.value) {
		jiraCb.isShowModal = !jiraCb.isShowModal
	}
	jiraCb.isJiraMode = !jiraCb.isJiraMode
}

const canExport = computed(() => !editor.isEditMode && (hasPermission(PermAllJiraExport) || hasPermission(PermOwnJiraExport)))
const isShowModal = computed(() => !editor.isEditMode && jiraCb.isSomethingWrong && !jiraCb.isJiraMode)
</script>

<template>
	<span
		v-if="canExport"
		id="jira-btn"
		class="fs-5 me-1"
		@click="handleJiraCheckboxChange"
		:aria-pressed="jiraCb.isShowModal || jiraCb.isJiraMode"
		v-one-tooltip="$t('jira.label')"
	>
		<img :src="iconPath" alt="jira" class="icon-hover" />
	</span>
</template>

<style lang="sass" scoped>
.icon-hover
  width: 26px
  height: auto
  filter: grayscale(90%)
  opacity: 90%
  transition: transform 0.2s ease-in-out, filter 0.3s ease
  &:hover
    opacity: 90%
    filter: none
    transform: scale(1.2)
</style>
